import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Drawer, Grid, IconButton, List } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import { MenuItem } from './MenuItem';
import { NestedMenuItem } from './NestedMenuItem';
import { closeDrawer } from 'main/store/common/reducer';
import { selectDrawer, selectUserRole } from 'main/store/common/selectors';

// const GAMES_RESULT_MENUS = [
//     { label: '勝敗表', path: '/games/standing' },
//     { label: 'スコア', path: '/games/scoreboard' }
// ];

const MEMBERS_MENUS = [
    { label: '共有動画', path: '/member-only/shared-videos' },
    // { label: 'おすすめ動画', path: '/member-only/recommended-videos' }
];

export const Sidemenu = () => {
    const dispatch = useDispatch();
    const userRole = useSelector(selectUserRole);
    const open = useSelector(selectDrawer);

    const membersMenus = useMemo(() => {
        const membersMenus = [...MEMBERS_MENUS];
        if (userRole && userRole === 'administrator') {
            membersMenus.push({ label: '管理者管理', path: '' });
        }
        return membersMenus;
    }, [userRole]);

    const handleClose = useCallback(() => {
        dispatch(closeDrawer());
    }, [dispatch]);

    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={handleClose}
        >
            <Grid container justifyContent="flex-end" onClick={handleClose} sx={{ height: 56, width: '40vw', maxWidth: 300 }}>
                <IconButton>
                    <ChevronLeftIcon />
                </IconButton>
            </Grid>
            <Divider />
            <List sx={{ pt: 1 }} >
                <MenuItem label="TOP" path="/" />
                <MenuItem label="チーム方針" path="/policy" />
                {/* <MenuItem label="スタッフ紹介" path="/staff" />
                <MenuItem label="卒団選手紹介" path="/graduation-players" />
                <MenuItem label="入団案内" path="/recruitment" /> */}
                <MenuItem label="スケジュール" path="/schedule" />
                {/* <NestedMenuItem parentLabel="試合結果" childMenus={GAMES_RESULT_MENUS} /> */}
                <MenuItem label="お問い合わせ" path="/contact" />
                <MenuItem label="思い出写真" path="/memory" />
                {userRole && <NestedMenuItem parentLabel="メンバーページ" childMenus={membersMenus} />}
            </List>
        </Drawer >
    )
}
